<template>
  <div
    :id="'hero-' + heroUniqueId"
    class="hero"
    :class="{ 'without-background': disableBox }"
    v-if="hasColors"
  >
    <div class="hero-background" v-if="!disableBox"></div>

    <template v-if="hasPrecoloredDesign">
      <div
        class="edit-team-name-btn btn"
        @click="showModal = !showModal"
        v-if="showName && dealerMode && !readOnly && !anonymousCrossOrigin"
      >
        <img src="~@/assets/edit.svg" alt="Customize icon" />
        <span>Customize team name</span>
      </div>

      <!-- Edit team name modal -->
      <transition name="fade">
        <Modal
          v-if="showModal"
          :darker="darker"
          :confirmationText="'save'"
          :hideButtonsContainer="!showButtons"
          :headerTitle="'Team name edition'"
          :isAboveAll="true"
          :showLoader='loadingDecorationsUpdate'
          @closeModal="showModal = false"
          @confirm="saveEditedHero()"
        >
          <template #content>
            <div class="decorations-container">
              <AddTextStamp
                :product="editableHero"
                :layout="finalLayout"
                :typeOfProduct="'editableHero'"
                :textStampSelectedOption="textStampToEdit"
                @changeTextStampSelected="
                  (option) => (textStampToEdit = option)
                "
              />

              <!-- Team Name and Number -->
              <TextStamp
                :showAsCommonImage="true"
                class="product-decoration-image svg-name"
                :layout="finalLayout"
                :fieldName="textStampToEdit"
                :fill="textStampToEditObject.fill"
                :outline="textStampToEditObject.outline"
                :value="textStampToEditObject.value"
                :font="textStampToEditObject.font"
              />
            </div>
          </template>
        </Modal>
      </transition>

      <template v-if="!singleLayer">
        <div
          class="hero-images"
          v-show="layersReady"
          :style="{ height: calculatedHeight }"
        >
          <img
            :crossorigin="anonymousCrossOrigin ? 'anonymous' : null"
            :key="'hero-base-' + heroUniqueId"
            @load="incLoadedItems"
            class="hero-image-layer"
            :src="baseUrl"
          />
          <img
            :crossorigin="anonymousCrossOrigin ? 'anonymous' : null"
            :key="'hero-layer-1-' + heroUniqueId"
            @load="incLoadedItems"
            class="hero-image-layer"
            :src="layer1"
          />
          <img
            :crossorigin="anonymousCrossOrigin ? 'anonymous' : null"
            :key="'hero-layer-2-' + heroUniqueId"
            @load="incLoadedItems"
            class="hero-image-layer"
            :src="layer2"
          />
          <img
            :crossorigin="anonymousCrossOrigin ? 'anonymous' : null"
            :key="'hero-layer-3-' + heroUniqueId"
            @load="incLoadedItems"
            class="hero-image-layer"
            :src="layer3"
          />
          <img
            :crossorigin="anonymousCrossOrigin ? 'anonymous' : null"
            :key="'hero-shadow-' + heroUniqueId"
            @load="incLoadedItems"
            class="hero-image-layer"
            :src="shadowUrl"
          />

          <div class="text-stamp-container">
            <!-- Team Name -->
            <TextStamp
              :style="{
                position: 'absolute',
                width: finalLayout.name.width,
                height: finalLayout.name.height,
                left: finalLayout.name.x,
                top: finalLayout.name.y,
              }"
              v-if="showName"
              v-show="layersReady"
              :showAsCommonImage="true"
              class="product-decoration-image svg-name"
              :layout="finalLayout"
              :fieldName="'name'"
              :fill="productName.fill"
              :outline="productName.outline"
              :value="productName.value"
              :font="productName.font"
            />
            <!-- Number -->
            <TextStamp
              v-if="showNumber"
              :style="{
                position: 'absolute',
                width: finalLayout.number.width,
                height: finalLayout.number.height,
                left: finalLayout.number.x,
                top: finalLayout.number.y,
              }"
              v-show="layersReady"
              :showAsCommonImage="true"
              class="product-decoration-image svg-name"
              :layout="finalLayout"
              :fieldName="'number'"
              :fill="productNumber.fill"
              :outline="productNumber.outline"
              :value="productNumber.value"
              :font="productNumber.font"
            />
            <!-- <img
          v-if="showNumber"
          v-show="layersReady"
          class="product-decoration-image svg-number"
          :style="{
            position: 'absolute',
            width: finalLayout.number.width,
            height: finalLayout.number.height,
            left: finalLayout.number.x,
            top: finalLayout.number.y,
          }"
          :src="
            textStampURL(
              productNumber.value,
              productNumber.fill,
              productNumber.outline
            )
          "
        /> -->

            <!-- Logo -->
            <img
              v-if="showLogo"
              v-show="layersReady"
              class="product-decoration-image svg-logo"
              :style="{
                position: 'absolute',
                width: logoProperties.width,
                height: logoProperties.height,
                left: logoProperties.x,
                top: logoProperties.y,
              }"
              :src="productLogo.content || productLogo.url"
            />
          </div>
        </div>
        <div class="loading" style="z-index: 2" v-show="!layersReady">
          <Loader />
        </div>
      </template>

      <template v-else>
        <img
          :crossorigin="anonymousCrossOrigin ? 'anonymous' : null"
          :key="'hero-shadow-' + heroUniqueId"
          @load="incLoadedItems"
          class="hero-image-layer"
          :src="singleLayerShadow"
          v-show="layersReady"
        />
        <!-- Team Name -->
        <div class="text-stamp-container">
          <TextStamp
            :style="{
              position: 'absolute',
              width: finalLayout.name.width,
              height: finalLayout.name.height,
              left: finalLayout.name.x,
              top: finalLayout.name.y,
            }"
            v-if="showName"
            v-show="layersReady"
            :showAsCommonImage="true"
            class="product-decoration-image svg-name"
            :layout="finalLayout"
            :fieldName="'name'"
            :fill="productName.fill"
            :outline="productName.outline"
            :value="productName.value"
            :font="productName.font"
          />
          <!-- Number -->
          <TextStamp
            v-if="showNumber"
            :style="{
              position: 'absolute',
              width: finalLayout.number.width,
              height: finalLayout.number.height,
              left: finalLayout.number.x,
              top: finalLayout.number.y,
            }"
            v-show="layersReady"
            :showAsCommonImage="true"
            class="product-decoration-image svg-name"
            :layout="finalLayout"
            :fieldName="'number'"
            :fill="productNumber.fill"
            :outline="productNumber.outline"
            :value="productNumber.value"
            :font="productNumber.font"
          />
          <!-- <img
          v-if="showNumber"
          v-show="layersReady"
          class="product-decoration-image svg-number"
          :style="{
            position: 'absolute',
            width: finalLayout.number.width,
            height: finalLayout.number.height,
            left: finalLayout.number.x,
            top: finalLayout.number.y,
          }"
          :src="
            textStampURL(
              productNumber.value,
              productNumber.fill,
              productNumber.outline
            )
          "
        /> -->

          <!-- Logo -->
          <img
            v-if="showLogo"
            v-show="layersReady"
            class="product-decoration-image svg-logo"
            :style="{
              position: 'absolute',
              width: logoProperties.width,
              height: logoProperties.height,
              left: logoProperties.x,
              top: logoProperties.y,
            }"
            :src="productLogo.content || productLogo.url"
          />
        </div>
        <div class="loading" style="z-index: 2" v-show="!layersReady">
          <Loader />
        </div>
      </template>
    </template>

    <template v-else-if="hasProduct">
      <ProductDisplay
        :product="product"
        :inheritedDesign="product.design"
        :layout="finalLayout"
        :precoloredDesign="precoloredDesign"
        :precoloredDesignShadow="precoloredDesignShadow"
        :designDimension="designDimension"
        :isThreekitAvailable="false"
      />
    </template>

    <div class="featured-box" v-if="showFeaturedBox">
      <div class="featured-box-title">featured design</div>
      <div class="featured-box-btn">{{ featuredDesignName }}</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import AddTextStamp from "@/components/Projects/Project/ActiveProduct/Decorations/AddTextStamp.vue";
import Loader from "@/components/Utils/Loader";
import Modal from "@/components/Utils/Modal";
import ProductDisplay from "@/components/Projects/Product/ProductDisplay/ProductDisplay.vue";
import TextStamp from "@/components/Projects/Product/ProductDisplay/TextStamp.vue";

export default {
  name: "HeroDisplay",
  computed: {
    ...mapState("auth", ["dealerMode"]),
    ...mapState("playbook", ["team_name"]),
    ...mapState("project", ["editableHero"]),
    ...mapGetters("project", [
      "color1",
      "color2",
      "color3",
      "textStampURL",
      "mapFlashColorName",
      "getProductTextStamp",
      "defaultLogo",
      "projectTeamName"
    ]),
    ...mapGetters("playbook", ["getPlaybookCards"]),

    totalLayers() {
      return this.hasPrecoloredDesign ? (this.singleLayer ? 1 : 5) : 0;
    },

    width() {
      return this.designDimension ? this.designDimension.width : 360;
    },

    height() {
      return this.designDimension ? this.designDimension.height : 1000;
    },

    calculatedHeight() {
      return this.zoomLevel ? `${(100 * this.zoomLevel).toFixed(2)}%` : `100%`;
    },

    calculatedWidth() {
      return this.zoomLevel ? `${(100 * this.zoomLevel).toFixed(2)}%` : `100%`;
    },

    /*translateY() {
      return this.zoomLevel ? `(${ Math.abs(1 -this.zoomLevel)*5 }%)` : `(0%);`
    },*/

    singleLayerShadow() {
      const colorName = this.isChromagear
        ? this.color1.chromagear_name
        : this.color1.stock_name;
      return `${this.precoloredDesign}_${colorName.toLowerCase()}.png`;
    },

    finalLayout() {
      return this.layoutOverride ? this.layoutOverride : this.product?.layout;
    },

    hasPrecoloredDesign() {
      return !!this.precoloredDesign;
    },

    showFeaturedBox() {
      return this.pageType !== "Cover" && this.isFeatured;
    },

    hasProduct() {
      return !!this.product;
    },

    shadowUrl() {
      return `${this.precoloredDesign}_shadow.png`;
    },

    hasColors() {
      return !!this.color1 && !!this.color2 && !!this.color3;
    },

    layer1() {
      if (!this.color1) return false;

      const colorName = this.isChromagear
        ? this.color1.chromagear_name
        : this.color1.stock_name;
      return `${this.precoloredDesign}_c1_${colorName.toLowerCase()}.png`;
    },

    layer2() {
      if (!this.color2) return false;
      const colorName = this.isChromagear
        ? this.color2.chromagear_name
        : this.color2.stock_name;
      return `${this.precoloredDesign}_c2_${colorName.toLowerCase()}.png`;
    },

    layer3() {
      if (!this.color3) return false;
      const colorName = this.isChromagear
        ? this.color3.chromagear_name
        : this.color3.stock_name;
      return `${this.precoloredDesign}_c3_${colorName.toLowerCase()}.png`;
    },

    baseUrl() {
      return `${this.precoloredDesign}_base.png`;
    },

    /* Logo */
    showLogo() {
      if (this.isSnapsheet) {
        //todo, buscar por sideKey (front, back, side)
        return !!this.product.decorations?.front?.logo?.id;
      } else {
        return !!this.logoProperties && !!this.productLogo && this.layersReady;
      }
    },

    logoProperties() {
      return this.finalLayout?.logo;
    },

    productLogo() {
      if (this.isSnapsheet) {
        return this.product.decorations?.front?.logo;
      } else {
        return this.product?.decorations?.front?.logo || this.defaultLogo;
      }
    },

    /* Text Stamps */

    productName() {
      const defaultValue = this.projectTeamName?.trim() || "teamName";
      return this.getProductTextStamp(this.editableHero, "name", defaultValue);
    },

    productNumber() {
      return this.getProductTextStamp(this.editableHero, "number", "00");
    },

    textStampToEditObject() {
      return this.textStampToEdit === "name"
        ? this.productName
        : this.productNumber;
    },

    showName() {
      return !!this.finalLayout?.name && !this.showLogo;
    },

    showNumber() {
      return !!this.finalLayout?.number;
    },

    layersReady() {
      return this.loadedItems >= this.totalLayers;
    },

    heroUniqueId() {
      const sliced = this.precoloredDesign?.split("/");
      return sliced ? sliced[sliced.length - 1] : "";
    },
  },

  methods: {
    ...mapActions("project", ["setEditableHero"]),
    ...mapActions("playbook", ["updateHeroDecorations"]),

    incLoadedItems() {
      this.loadedItems += 1;
    },

    async saveEditedHero() {
      try {
        this.loadingDecorationsUpdate = true;
        const sportSlug = this.getPlaybookCards.find((s) => {
          return s.name?.toLowerCase() === this.sportName?.toLowerCase();
        })?.slug;

        const payload = {
          layout: this.layoutIndex,
          column: this.columnIndex,
          block: this.itemIndex,
        };

        await this.updateHeroDecorations({
          ...payload,
          product: {
            ...this.product,
            decorations: { ...this.editableHero.decorations },
            layoutIndex: this.layoutIndex,
            sport: sportSlug,
          },
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingDecorationsUpdate = false;
        this.showModal = false;
        this.textStampToEdit = "name";
      }
    },
  },

  mounted() {
    if (this.showName || this.showNumber) this.setEditableHero(this.product);
  },

  data() {
    return {
      loadedItems: 10,
      loadingDecorationsUpdate: false,

      //Modal data
      showModal: false,
      textStampToEdit: "name",
    };
  },

  props: {
    product: {
      type: Object,
    },
    disableBox: {
      type: Boolean,
    },
    precoloredDesign: {
      Type: String,
    },
    designDimension: {
      type: Object,
    },
    precoloredDesignShadow: {
      type: String,
    },
    singleLayer: {
      type: Boolean,
    },
    layoutOverride: {},
    anonymousCrossOrigin: {
      type: Boolean,
    },
    isChromagear: {
      type: Boolean,
    },
    layoutIndex: {
      type: Number,
    },
    columnIndex: {
      type: Number,
    },
    itemIndex: {
      type: Number,
    },
    sportName: {
      type: String,
    },
    readOnly: {
      type: Boolean,
    },
    zoomLevel: {
      type: Number,
    },
    pageType: {
      type: String,
    },
    isFeatured: {
      type: Boolean,
    },
    featuredDesignName: {
      type: String,
    },
  },
  components: {
    AddTextStamp,
    Loader,
    Modal,
    ProductDisplay,
    TextStamp,
  },
};
</script>

<style lang="scss" scoped>
#app {
  .hero {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: end;
    position: relative;
    .featured-box {
      position: absolute;
      right: 10%;
      bottom: 5%;
      display: flex;
      flex-direction: column;
      background-color: rgba(0, 0, 0, 0.5);
      padding: 0.5em;
      .featured-box-title {
        font-family: "Forza";
        font-style: italic;
        text-transform: uppercase;
        font-size: 1.5em;
        color: white;
      }
      .featured-box-btn {
        padding: 0.3em;
        font-size: 1em;
        background: gray;
        color: white;
        text-transform: uppercase;
        text-align: center;
      }
    }
    .hero-images {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: end;
    }
    .loading {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      &.modal-loading {
        background: rgba(0, 0, 0, 0.089);
      }
    }
    &.without-background {
      background-color: transparent;
    }
    img.hero-image-layer {
      position: absolute;
      right: 0;
      bottom: 0;
      height: 100%;
    }
    .hero-background {
      z-index: 0;
      position: absolute;
      left: 0;
      top: 0;
      background: linear-gradient(
        0deg,
        rgba(255, 255, 255, 1) 0%,
        rgba(230, 230, 230, 1) 50%,
        rgba(221, 221, 221, 1) 100%
      );
      width: 340px;
      max-width: 95%;
      height: 100%;
    }
    .edit-team-name-btn {
      color: white;
      display: none;
      align-items: center;
      padding: 0.3em 1em;
      z-index: 10;
      background: $dark;
      position: absolute;
      top: 30%;
      left: 20%;
      text-transform: capitalize;

      span {
        color: white;
      }
      img {
        margin: 0 0.5em;
        margin-left: 0;
      }
    }
    &:hover {
      .edit-team-name-btn {
        display: flex;
      }
    }
    svg {
      z-index: 1;
      max-height: 100%;
    }
    .product-decoration-image {
      max-width: 100%;
      max-height: 100%;
    }

    .modal-wrapper {
      width: 50%;
      height: 60%;
      max-width: 720px;
      max-height: 720px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: white;
      border-radius: 3px;
      position: relative;
      .header,
      .content,
      .save-cancel-container {
        padding: 0 2rem;
        width: 100%;
      }

      .header {
        border-bottom: 1px solid $borderColor;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 1rem;
        padding: 1.2rem 2rem;
        width: 100%;
        p {
          text-transform: capitalize;
        }
      }

      .content {
        display: flex;
        flex-direction: column;
        margin-bottom: 0.5rem;
        height: 60%;
        flex-grow: 1;

        .decorations-container {
          display: flex;
          /* align-items: center; */
          justify-content: space-between;
          flex-grow: 1;
          width: 100%;
          height: 50%;

          ::v-deep #edit-textstamps {
            width: 45%;
            overflow-y: auto;
            .labels-in-column {
              width: 100%;
            }
          }
          ::v-deep .product-decoration-image {
            width: 50%;
            max-height: 50%;
            border: 1px solid $borderColor;
            border-radius: 1rem;
            padding: 0.5rem;
            margin: auto 0;
          }
        }
      }

      .save-cancel-container {
        margin-top: auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 1rem;
        padding-bottom: 1rem;
        border-top: 1px solid $borderColor;
        .btn {
          background: black;
          color: white;
          margin-left: auto;
          width: 10rem;
          text-transform: capitalize;
        }
        .btn-transparent {
          background: transparent;
          margin-left: 0;
          margin-right: auto;
          color: $grey-dark;
          display: flex;
          align-items: center;
          img {
            width: 18px;
            margin-top: 1px;
            margin-right: 3px;
          }
        }
      }
    }
  }
}
</style>

<!-- cover rules -->
<style lang="scss">
.hero-levels-1 {
  &.hero-level-0 {
    &.hero-index-0 {
      .hero-image-layer {
        right: 20% !important;
      }
      .text-stamp-container {
        right: 20% !important;
        position: absolute;
        width: 100%;
        height: 100%;
      }
    }
    &.hero-index-1 {
      .hero-image-layer {
        right: -20% !important;
      }
      .text-stamp-container {
        right: -20% !important;
        position: absolute;
        width: 100%;
        height: 100%;
      }
    }
  }

  &.hero-level-1 {
    &.hero-index-0 {
      &.hero-indexes-1 {
        .hero-image-layer {
          right: -25% !important;
        }
        .text-stamp-container {
          right: -25% !important;
          position: absolute;
          width: 100%;
          height: 100%;
        }
      }
    }
    &.hero-index-1 {
      .hero-image-layer {
        right: 25% !important;
      }
      .text-stamp-container {
        right: 25% !important;
        position: absolute;
        width: 100%;
        height: 100%;
      }
    }
  }
}

.hero-levels-2 {
  &.hero-level-0 {
    &.hero-index-0 {
      &.hero-indexes-1 {
        .hero-image-layer {
          right: 25% !important;
        }
        .text-stamp-container {
          right: 25% !important;
          position: absolute;
          width: 100%;
          height: 100%;
        }
      }
    }
    &.hero-index-0 {
      &.hero-indexes-1 {
        .hero-image-layer {
          right: -25% !important;
        }
        .text-stamp-container {
          right: -25% !important;
          position: absolute;
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  &.hero-level-1 {
    &.hero-index-0 {
      .hero-image-layer {
        right: 0% !important;
      }
      .text-stamp-container {
        right: 0% !important;
        position: absolute;
        width: 100%;
        height: 100%;
      }
    }
    &.hero-index-1 {
      .hero-image-layer {
        right: 7% !important;
      }
      .text-stamp-container {
        right: 7% !important;
        position: absolute;
        width: 100%;
        height: 100%;
      }
    }
  }

  &.hero-level-2 {
    &.hero-index-0 {
      .hero-image-layer {
        right: 0% !important;
      }
      .text-stamp-container {
        right: 0% !important;
        position: absolute;
        width: 100%;
        height: 100%;
      }
    }
    &.hero-index-0 {
      .hero-image-layer {
        right: 0% !important;
      }
      .text-stamp-container {
        right: 0% !important;
        position: absolute;
        width: 100%;
        height: 100%;
      }
    }
  }
}
//3 players
.cover-hero.hero-level-0.hero-index-0.hero-levels-1.hero-indexes-1 {
  margin-right: 15%;
}

//4 players
.cover-hero.hero-level-1.hero-index-0.hero-levels-2.hero-indexes-1 {
  margin-right: 8%;
}

//5 players
.cover-hero.hero-level-0.hero-index-0.hero-levels-2.hero-indexes-1 {
  margin-right: 45%;
}
</style>
